module.exports = __webpack_public_path__ + "img/partnership_02_mobile.f540a48f.jpg";